import './App.css';

import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
// require normalized overrides
import messages from './locale/translations/index';
import Routes from './routes';
import store from './services/redux/store';
import { ConfigProvider, theme } from 'antd';
import enUS from 'antd/es/locale/en_US';
import esES from 'antd/es/locale/es_ES';

const locales = {
  en: enUS,
  es: esES,
};

function App() {
  const browserLocale = navigator.language || navigator.languages[0];
  return (
    <Provider store={store}>
      <IntlProvider
        locale={navigator.language}
        messages={messages(navigator.language)}
      >
        <ConfigProvider
          locale={locales[browserLocale.split('-')[0]] || enUS}
          theme={{
            token: {
              colorPrimary: '#ff0000',
              fontFamily: 'Acciona Font',
              colorBgContainerDisabled: 'rgba(0, 0, 0, 0.2)',
              borderRadius: 0,
            },
            algorithm: theme.defaultAlgorithm,
            components: {
              DatePicker: {
                cellHeight: 30,
                cellWidth: 42,
                timeCellHeight: 30,
                timeColumnWidth: 42,
                cellBgDisabled: 'rgba(0, 0, 0, 0.04)',
              },
              Input: {
                inputFontSize: '16px',
                activeBorderColor: 'transparent',
                addonBg: '#666',
              },
              Layout: {
                siderBg: '#ffffff',
              },
              Menu: {
                itemSelectedBg: '#E6E6E6',
                itemSelectedColor: '#ff0000',
              },
              Select: {
                selectorBg: '#f1f1f1',
                optionHeight: 47,
                activeBorderColor: 'transparent',
                colorBorder: 'transparent',
                fontSize: '15px',
              },
              Tag: {
                fontSize: '12px!important',
              },
              Descriptions: {
                contentColor: '#666666',
                itemPaddingBottom: '0px',
              },
              Segmented: {
                itemSelectedBg: '#ff0000',
                itemSelectedColor: '#ffffff',
                itemHoverBg: '#ff000080',
                itemHoverColor: '#ffffff',
                itemActiveBg: '#ff0000',
              },
              Tabs: {
                colorBorderSecondary: '#dcdbdb',
              },
              Pagination: {
                itemActiveBg: '#ff0000',
                fontWeightStrong: 'normal',
              },
              Button: {
                colorLink: '#666666',
                colorLinkHover: '#666666',
              },
            },
          }}
        >
          <Routes />
        </ConfigProvider>
      </IntlProvider>
    </Provider>
  );
}

export default App;
